import { render, staticRenderFns } from "./AdminActivitiesTableRow.vue?vue&type=template&id=dff5f47a&"
import script from "./AdminActivitiesTableRow.vue?vue&type=script&lang=js&"
export * from "./AdminActivitiesTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports